import StoriesFirstBlock from './StoriesFirstBlock'

export default StoriesFirstBlock
